<template>
    <div>
        <price-element-min-pax :amount.sync="service.minPax"></price-element-min-pax>
        <price-element-max-pax :amount.sync="service.maxPax"></price-element-max-pax>
        <price-element-min-nights :amount.sync="service.minNights"></price-element-min-nights>
        <price-element-max-nights :amount.sync="service.maxNights"></price-element-max-nights>
        <price-element-breakfast :amount.sync="service.breakfast"></price-element-breakfast>
    </div>
</template>

<script>
export default {
  data () {
    return {
      priceRule: {}
    }
  },
  props: {
    service: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/Perunitpernight.vue